import { useCallback } from "react";

import { createError, parseGraphQLError } from "utils";

import { usePagination } from "hooks";
import useRequest from "hooks/useRequest";
import createResolverFactory from "components/QueryClient/ResolverFactory";

function useProcesses() {
  const queryFactory = useCallback(() => {
    const query = `
        query getProcesses($pageSize: Int, $after: String) {
          processes(first: $pageSize, after: $after, includeStats: false, hasWorkflows: true) {
            edges {
              node {
                id
                name
                numWorkflows
              }
            }
            totalCount
            pageInfo {
              endCursor
              hasNextPage
            }
          }
        }`;

    const resolver = ({ data: { processes } }) => {
      return {
        data: processes?.edges?.map(({ node }) => {
          return { ...node };
        }),
        totalCount: processes?.totalCount,
        pageInfo: processes?.pageInfo,
      };
    };

    return { query: query, resolver: createResolverFactory(resolver) };
  }, []);

  const { req } = useRequest(queryFactory);

  const page = usePagination(req, {
    options: {
      pageSizes: [5, 15, 30],
    },
  });

  const generateErrorMsg = useCallback(() => {
    return createError({
      ...parseGraphQLError(page.error),
      name: "GetProcesses",
      defaultMessage:
        "Failed to load processes. Please refresh the page or contact support for further assistance.",
    }).message;
  }, [page.error]);

  return {
    ...page,
    initialFetch: page.loading && page.fetchCount === 0,
    error: page.error && !page.loading ? generateErrorMsg() : null,
  };
}

export default useProcesses;
